import type { TutorialDefinition, TutorialSection } from './types';
import coreOnboarding from './definitions/coreOnboarding';
import learningContent from './definitions/learningContent';
import evaluationPlan from './definitions/evaluationPlan';
import classPresentation from './definitions/classPresentation';
import classWorksheet from './definitions/classWorksheet';
import recordMemosWeeklyGuide from './definitions/recordMemosWeeklyGuide';
import assignmentNote from './definitions/assignmentNote';
import pointCoinItem from './definitions/pointCoinItem';
import todoNote from './definitions/todoNote';
import budgetNote from './definitions/budgetNote';
import dashboardNote from './definitions/dashboardNote';
import classAlarm from './definitions/classAlarm';
import mainPresentation from './definitions/mainPresentation';

export const TUTORIAL_DEFINITIONS: TutorialDefinition[] = [
  coreOnboarding,
  learningContent,
  evaluationPlan,
  classPresentation,
  classWorksheet,
  recordMemosWeeklyGuide,
  assignmentNote,
  pointCoinItem,
  todoNote,
  budgetNote,
  dashboardNote,
  classAlarm,
  mainPresentation,
];

const TUTORIAL_DEFINITIONS_MAP: Record<string, TutorialDefinition> = TUTORIAL_DEFINITIONS.reduce(
  (acc, def) => {
    acc[def.id] = def;
    return acc;
  },
  {} as Record<string, TutorialDefinition>
);

export function getTutorialDefinition(tutorialId: string): TutorialDefinition | undefined {
  return TUTORIAL_DEFINITIONS_MAP[tutorialId];
}

/** steps에서 `section`이 지정된 지점들을 모아 "중간부터 시작하기" 목록을 만든다. */
export function getTutorialSections(def: TutorialDefinition): TutorialSection[] {
  const sections: TutorialSection[] = [];
  def.steps.forEach((step, index) => {
    if (step.section) sections.push({ label: step.section, stepIndex: index });
  });
  return sections;
}

export type { TutorialDefinition, TutorialStep, TutorialSection, TutorialRecover } from './types';
